module.exports = __webpack_public_path__ + "static/media/help.7460a5b3.png";